import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";
import run from "../assets/run.webp";
import tutor from "../assets/tutor.webp";
import slide1 from "../assets/slide1.webp";
import slide2 from "../assets/slide 2.1.webp";
import slide3 from "../assets/slide 3.webp";
import slide4 from "../assets/slide 4.webp";
import slide5 from "../assets/slide 5.webp";
import slide6 from "../assets/slide 6.webp";
import { FaUsers, FaDollarSign, FaUniversity } from "react-icons/fa";

export default function Home() {
  const [email, setEmail] = useState("");
  const [current, setCurrent] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const carouselSlides = [
    { img: slide1, caption: "The Watermelon Run 2025", tag: "Event" },
    { img: slide2, caption: "Supporting our community", tag: "Event" },
    { img: slide3, caption: "Making a difference", tag: "Scholar" },
    { img: slide4, caption: "Education through education", tag: "Scholar" },
    { img: slide5, caption: "The SOWS Fund", tag: "Event" },
    { img: slide6, caption: "Building brighter futures", tag: "Scholar" },
  ];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % carouselSlides.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const subscribe = async () => {
    if (!email) return;
    await addDoc(collection(db, "subscribers"), { email });
    setEmail("");
    alert("Subscribed!");
  };

  useEffect(() => {
    const counters = document.querySelectorAll(".counter");
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const counter = entry.target;
          const target = +counter.getAttribute("data-target");
          let count = 0;
          const update = () => {
            const increment = target / 60;
            if (count < target) {
              count += increment;
              counter.innerText = Math.floor(count).toLocaleString();
              requestAnimationFrame(update);
            } else {
              counter.innerText = target.toLocaleString();
            }
          };
          update();
          obs.unobserve(counter);
        }
      });
    }, { threshold: 0.5 });
    counters.forEach(counter => observer.observe(counter));
  }, []);

  const CarouselSection = () => (
    <div style={{ position: "relative", width: "100%", height: "100%", minHeight: isMobile ? "300px" : "600px" }}>
      {carouselSlides.map((slide, i) => (
        <div key={i} style={{
          position: "absolute", inset: 0,
          opacity: i === current ? 1 : 0,
          transition: "opacity 0.8s ease",
          zIndex: i === current ? 1 : 0
        }}>
          <img src={slide.img} alt={slide.caption} style={{
            width: "100%", height: "100%", objectFit: "cover"
          }} />
          {/* ✅ SHADOW GRADIENT so text is readable */}
          <div style={{
            position: "absolute", inset: 0,
            background: "linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.1) 60%, transparent 100%)"
          }} />
        </div>
      ))}

      {/* DOTS */}
      <div style={{
        position: "absolute", top: "12px", right: "12px",
        display: "flex", gap: "6px", zIndex: 10
      }}>
        {carouselSlides.map((_, i) => (
          <div key={i} onClick={() => setCurrent(i)} style={{
            width: i === current ? "18px" : "8px", height: "8px",
            borderRadius: "8px",
            background: i === current ? "#e57386" : "rgba(255,255,255,0.5)",
            cursor: "pointer", transition: "all 0.3s"
          }} />
        ))}
      </div>
    </div>
  );

  return (
    <>
      {/* ============ MOBILE HERO ============ */}
      {isMobile ? (
        <>
          {/* MOBILE - carousel with text overlay + fade into card below */}
          <div style={{
            background: "#f6f0dc",
            borderRadius: "20px",
            overflow: "hidden",
            margin: "16px 0",
            boxShadow: "0 8px 24px rgba(229,115,134,0.3)"
          }}>
            {/* CAROUSEL ON TOP */}
            <div style={{ position: "relative", width: "100%", height: "70vw", minHeight: "260px", maxHeight: "420px", overflow: "hidden" }}>
              {carouselSlides.map((slide, i) => (
                <div key={i} style={{
                  position: "absolute", inset: 0,
                  opacity: i === current ? 1 : 0,
                  transition: "opacity 0.8s ease",
                  zIndex: i === current ? 1 : 0
                }}>
                  <img src={slide.img} alt={slide.caption} style={{
                    width: "100%", height: "100%", objectFit: "cover"
                  }} />
                  {/* ✅ STRONG shadow so text is readable */}
                  <div style={{
                    position: "absolute", inset: 0,
                    background: "linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.2) 50%, transparent 100%)"
                  }} />
                </div>
              ))}

              {/* TEXT OVERLAY ON CAROUSEL */}
              <div style={{
                position: "absolute", bottom: 0, left: 0, right: 0,
                padding: "20px 16px", zIndex: 10, textAlign: "center"
              }}>
                <h1 style={{
                  fontSize: "22px", color: "#e57386", margin: "0 0 6px",
                  textShadow: "0 2px 8px rgba(0,0,0,0.9)", fontWeight: "bold"
                }}>
                  Seeds of a Watermelon Scholarship Fund
                </h1>
                <h2 style={{
                  fontSize: "14px", color: "#f6f0dc", margin: 0,
                  textShadow: "0 2px 8px rgba(0,0,0,0.9)", fontWeight: "600"
                }}>
                  Empowering Gazan Students Through Education
                </h2>
              </div>

              {/* DOTS */}
              <div style={{
                position: "absolute", top: "12px", right: "12px",
                display: "flex", gap: "6px", zIndex: 10
              }}>
                {carouselSlides.map((_, i) => (
                  <div key={i} onClick={() => setCurrent(i)} style={{
                    width: i === current ? "18px" : "8px", height: "8px",
                    borderRadius: "8px",
                    background: i === current ? "#e57386" : "rgba(255,255,255,0.5)",
                    cursor: "pointer", transition: "all 0.3s"
                  }} />
                ))}
              </div>

              {/* ✅ FADE INTO CARD BELOW */}
              <div style={{
                position: "absolute", bottom: 0, left: 0, right: 0,
                height: "80px",
                background: "linear-gradient(to top, #f6f0dc 0%, transparent 100%)",
                zIndex: 5, pointerEvents: "none"
              }} />
            </div>

            {/* BODY TEXT INSIDE SAME CARD */}
            <div style={{ padding: "12px 20px 28px" }}>
              <p style={{ fontSize: "16px", lineHeight: "1.7", marginBottom: "12px", marginTop: 0 }}>
                We provide scholarships to Palestinian students in Gaza,
                helping them access higher education and build a brighter future.
              </p>
              <p style={{ fontSize: "16px", lineHeight: "1.7", marginBottom: "20px" }}>
                Each scholarship awarded is more than financial aid — it is a commitment to the idea
                that knowledge can transcend borders, that opportunity should not be determined by
                circumstance, and that the right to learn is universal.
              </p>
              <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", justifyContent: "center" }}>
                <Link to="/donate" className="pink-btn">Donate</Link>
                <Link to="/tutoring-program" className="pink-outline">Get Involved</Link>
              </div>
            </div>
          </div>
        </>
      ) : (
        /* ============ DESKTOP HERO ============ */
        <div style={{
          display: "flex",
          background: "#f6f0dc",
          borderRadius: "30px",
          margin: "50px auto",
          width: "85%",
          overflow: "hidden",
          minHeight: "600px",
          boxShadow: "0 8px 24px rgba(229,115,134,0.3)",
        }}>
          {/* LEFT - TEXT */}
          <div style={{
            flex: 1, padding: "70px 40px 70px 60px",
            display: "flex", flexDirection: "column", justifyContent: "center"
          }}>
            <h1 style={{ fontSize: "38px", color: "#e57386", marginTop: 0 }}>
              Seeds of a Watermelon Scholarship Fund
            </h1>
            <h2 style={{ fontSize: "22px", color: "#3d4f0c", marginBottom: "16px" }}>
              Empowering Gazan Students Through Education
            </h2>
            <p style={{ fontSize: "18px", lineHeight: "1.7", marginBottom: "12px" }}>
              We provide scholarships to Palestinian students in Gaza,
              helping them access higher education and build a brighter future.
            </p>
            <p style={{ fontSize: "18px", lineHeight: "1.7" }}>
              Each scholarship awarded is more than financial aid — it is a commitment to the idea
              that knowledge can transcend borders, that opportunity should not be determined by
              circumstance, and that the right to learn is universal.
            </p>
            <div style={{ marginTop: "25px", display: "flex", gap: "12px", flexWrap: "wrap" }}>
              <Link to="/donate" className="pink-btn">Donate</Link>
              <Link to="/tutoring-program" className="pink-outline">Get Involved</Link>
            </div>
          </div>

          {/* RIGHT - CAROUSEL */}
          <div style={{ flex: 1, position: "relative", minHeight: "600px" }}>
            {/* ✅ FADE from left into text */}
            <div style={{
              position: "absolute", top: 0, left: 0, bottom: 0, width: "150px",
              background: "linear-gradient(to right, #f6f0dc 0%, transparent 100%)",
              zIndex: 2, pointerEvents: "none"
            }} />
            {carouselSlides.map((slide, i) => (
              <div key={i} style={{
                position: "absolute", inset: 0,
                opacity: i === current ? 1 : 0,
                transition: "opacity 0.8s ease",
                zIndex: i === current ? 1 : 0
              }}>
                <img src={slide.img} alt={slide.caption} style={{
                  width: "100%", height: "100%", objectFit: "cover"
                }} />
                {/* ✅ SHADOW GRADIENT for text readability */}
                <div style={{
                  position: "absolute", inset: 0,
                  background: "linear-gradient(to top, rgba(0,0,0,0.6) 0%, transparent 60%)"
                }} />
              </div>
            ))}
            <div style={{
              position: "absolute", bottom: "20px", left: 0, right: 0,
              display: "flex", alignItems: "center", justifyContent: "center",
              gap: "12px", zIndex: 10
            }}>
              <button onClick={() => setCurrent(prev => (prev - 1 + carouselSlides.length) % carouselSlides.length)}
                style={{
                  background: "rgba(255,255,255,0.2)", border: "none", color: "white",
                  fontSize: "20px", borderRadius: "50%", width: "36px", height: "36px",
                  cursor: "pointer", backdropFilter: "blur(4px)", display: "flex",
                  alignItems: "center", justifyContent: "center"
                }}>‹</button>
              {carouselSlides.map((_, i) => (
                <div key={i} onClick={() => setCurrent(i)} style={{
                  width: i === current ? "24px" : "10px", height: "10px",
                  borderRadius: "10px",
                  background: i === current ? "#e57386" : "rgba(255,255,255,0.5)",
                  cursor: "pointer", transition: "all 0.3s"
                }} />
              ))}
              <button onClick={() => setCurrent(prev => (prev + 1) % carouselSlides.length)}
                style={{
                  background: "rgba(255,255,255,0.2)", border: "none", color: "white",
                  fontSize: "20px", borderRadius: "50%", width: "36px", height: "36px",
                  cursor: "pointer", backdropFilter: "blur(4px)", display: "flex",
                  alignItems: "center", justifyContent: "center"
                }}>›</button>
            </div>
          </div>
        </div>
      )}

      {/* IMPACT */}
      <div className="impact-section">
        <h2>Our Impact</h2>
        {isMobile ? (
          <div style={{ width: "100%", padding: "0 12px" }}>
        {/* MOBILE - Funds Raised centered on top */}
<div style={{ display: "flex", justifyContent: "center", marginBottom: "50px" }}>
  <div className="impact-card" style={{ maxWidth: "280px", width: "100%" }}>
    <FaDollarSign className="impact-icon" />
    <h3 className="counter" style={{ fontSize: "clamp(36px, 15vw, 100px)" }} data-target="200000">0</h3>
    <p>Funds Raised</p>
  </div>
</div>
{/* MOBILE - Other two centered side by side */}
<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", justifyItems: "center" }}>
  <div className="impact-card" style={{ width: "100%" }}>
    <FaUniversity className="impact-icon" />
    <h3 className="counter" style={{ fontSize: "clamp(44px, 20vw, 90px)" }} data-target="36">0</h3>
    <p>Scholarships Awarded</p>
  </div>
  <div className="impact-card" style={{ width: "100%" }}>
    <FaUsers className="impact-icon" />
    <h3 className="counter" style={{ fontSize: "clamp(44px, 20vw, 90px)" }} data-target="22">0</h3>
    <p>Students Tutored</p>
  </div>
</div>
          </div>
        ) : (
          <div className="impact-grid">
            <div className="impact-card">
              <FaDollarSign className="impact-icon" />
              <h3 className="counter" data-target="200000">0</h3>
              <p>Funds Raised</p>
            </div>
            <div className="impact-card">
              <FaUniversity className="impact-icon" />
              <h3 className="counter" data-target="36">0</h3>
              <p>Scholarships Awarded</p>
            </div>
            <div className="impact-card">
              <FaUsers className="impact-icon" />
              <h3 className="counter" data-target="22">0</h3>
              <p>Students Tutored</p>
            </div>
          </div>
        )}
      </div>

      {/* PROGRAMS */}
      <div className="section-card">
        <h2 className="section-title">Our Programs</h2>

        <div className="program-row">
          <div className="program-text">
            <h3>The Watermelon Run</h3>
            <p>
              The Watermelon Run 5K is about making a tangible difference for a community afflicted
              by unimaginable tragedy. Every stride you take and every dollar you raise directly
              supports these courageous young men and women in their pursuit of a free future.
              Interested in participating or volunteering? Sign up for our mailing list below to
              stay updated on event details!
            </p>
            <Link to="/run" className="pink-btn" style={{ display: "inline-block", marginTop: "20px" }}>
              Learn More
            </Link>
          </div>
          <img src={run} alt="run" />
        </div>

        <div className="program-row reverse">
          {!isMobile && <img src={tutor} alt="tutor" />}
          <div className="program-text">
            <h3>Free Tutoring Services</h3>
            <p>
              Our volunteer tutors provide free, one-on-one academic support to students in subjects
              ranging from math to English, college preparation and beyond.
            </p>
            <p>
              All of our tutors are passionate, dedicated students themselves, bringing fresh
              perspective and relatable guidance to every session. Best of all, this service is
              completely free to families.
            </p>
            <Link to="/tutoring-program" className="pink-btn" style={{ display: "inline-block", marginTop: "20px" }}>
              Find a Tutor
            </Link>
            {isMobile && <img src={tutor} alt="tutor" style={{ width: "100%", borderRadius: "15px", marginTop: "20px" }} />}
          </div>
        </div>
      </div>

      {/* MAILING LIST */}
      <div className="mailing">
        Join our mailing list to stay up to date
        <div style={{ marginTop: "20px" }}>
          <input
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <button onClick={subscribe}>Join</button>
        </div>
      </div>
    </>
  );
}